import Register from './components/register/register.component';
import './App.css';
import Header from './components/header/header.component';

function App() {
  return (
    <div className="App">
      <div className="container">
        <Header />
        <Register />
      </div>
    </div>
  );
}

export default App;
